import { render, staticRenderFns } from "./AvatarTooltiped.vue?vue&type=template&id=2e551c4a&"
import script from "./AvatarTooltiped.vue?vue&type=script&lang=js&"
export * from "./AvatarTooltiped.vue?vue&type=script&lang=js&"
import style0 from "./AvatarTooltiped.vue?vue&type=style&index=0&id=2e551c4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports